<app-doc-viewer title="Language" subtitle="Core">
  <p>Translate your angular application</p>

  <li>Import <code>IgoLanguageModule</code> only once</li>
  <li>
    Configure the
    <a
      href="https://github.com/infra-geo-ouverte/igo2-lib/tree/master/projects/demo/src/locale"
      >locale files</a
    >
  </li>

  <app-example-viewer codeFolder="core/language">
    <div class="d-flex actions-container">
      <button mat-raised-button (click)="changeLanguage('en')">English</button>
      <button mat-raised-button (click)="changeLanguage('fr')">Français</button>
    </div>

    <div class="m-t-12">
      {{ 'welcome' | translate: app }}
    </div>
  </app-example-viewer>
</app-doc-viewer>
